
import { acfmap } from '../components/maps.js';
export default {
	init() {
		// JavaScript to be fired on the branch page, after the init JS


	},
	finalize() {

		acfmap();


		// Upload bulletin board

		$('.bulletin-upload-form').on('submit', function (el) {
			var $form = $(this);
			$.ajax({
				url: $form.attr('action'),
				data: new FormData(this),
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				type: 'POST',
				beforeSend: function () {
					$form.slideUp();
					$('.bulletin-loading').slideDown();
				},

				success: function () {
					$('.bulletin-loading').slideUp();
					$('.bulletin-success').slideDown();
					setTimeout(function () {
						$('#bulletinboardUpload').modal('hide')
					}, 3000)
				},

				error: function () {
					$form.slideDown();
				},

			});

			el.preventDefault();

		});

		$('.header-slides').slick({
			arrows: false,
		});

		$(".header-slides-control--next").on("click", function () {
			$(".header-slides").slick("slickNext")
		});

		$(".header-slides-control--prev").on("click", function () {
			$(".header-slides").slick("slickPrev")
		});

		$('.pos-slides').slick({
			prevArrow: '<button type="button" class="slider-control shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
			nextArrow: '<button type="button" class="slider-control shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
		});

		$(".pos-slider .next").on("click", function () {
			$(".pos-slides").slick("slickNext")
		});

		$(".pos-slider .prev").on("click", function () {
			$(".pos-slides").slick("slickPrev")
		});

		$('[data-toggle="tooltip"]').tooltip();

		$('.branch-gallery-slider').slick({
			dots: false,
			prevArrow: '<button type="button" class="slider-control shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
			nextArrow: '<button type="button" class="slider-control shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
			infinite: true,
			speed: 300,
			slidesToShow: 1,
		});

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/branch.js